import axios from 'axios';
import {
  getLocalStorage,
  getSessionStorage,
  setSessionStorage,
} from '../common/helpers/helpers';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(
  (config) => {
    const sessionUser = getSessionStorage('auth');
    const { token } = getLocalStorage('auth') || {};
    const params = new URLSearchParams(window.location.search);
    const landingPageToken = params.get('token');
    const tokenToUse = landingPageToken || sessionUser?.token || token;

    if (tokenToUse) {
      config.headers.Authorization = `Bearer ${tokenToUse}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;

      if (status === 401 || status === 403) {
        sessionStorage.removeItem('store');
        localStorage.removeItem('store');
      }
    }

    return Promise.reject(error);
  }
);

export const setApiToSessionStorage = (newUser) => {
  setSessionStorage(newUser);
};

export default api;
